import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import IMG_LIGHT from 'assets/tags/dummy-tags.jpg';
import IMG_DARK from 'assets/tags/dummy-tags-dark.jpg';
import { selectCurrentSalonCalendarMode } from 'selectors/currentSalon.selectors';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

import CN from './DummyBannerImage.module.scss';

const DummyBannerImage = ({ show, className, calendarMode, children, onClick }) => {
  const isLightMode = calendarMode === 'light';
  const isDarkMode = calendarMode === 'dark';
  const isBrightMode = !isLightMode && !isDarkMode;
  const image = isDarkMode ? IMG_DARK : IMG_LIGHT;

  return (
    fromAnyToBool(show) && (
      <div
        role="button"
        tabIndex={0}
        onClick={onClick}
        className={cn({
          className,
          [CN.container]: true,
          light: isLightMode,
          dark: isDarkMode,
          bright: isBrightMode,
        })}
      >
        <div className={CN.banner}>{children}</div>
        <img src={image} className={CN.image} alt="client tags" />
      </div>
    )
  );
};

const mapStateToProps = (state) => ({
  calendarMode: selectCurrentSalonCalendarMode(state),
});

export default connect(mapStateToProps)(DummyBannerImage);
